import script from "./BlogItemMainLayuot.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogItemMainLayuot.vue?vue&type=script&setup=true&lang=js"

import "./BlogItemMainLayuot.vue?vue&type=style&index=0&id=7c6bf2df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6bf2df"]])

export default __exports__